import React from 'react';
import { Card } from 'antd';
import { MdHourglassEmpty } from 'react-icons/md';

/**
 * @component
 * @category Search Page
 * @name StartCard
 * @description When Search bar page loads for first time and it doesn't have FCL/LCL/AIR types results card json at all,
 * then show this Component on results section of Search bar page as a placeholder.
 * <br> <br>
 * **Example**
 * ```js
 *  <StartCard />
 * ```
 */
const StartCard = () => {
  return (
    <>
        <div>
      <div className="no-result testR1" style={{marginTop: '-45px',marginBottom:"20px"}}>
        <Card className="no-result-card testR1">
          <div className="no-result-card-content">
            <div
              style={{
                fontSize: '16px',
                width: '100px',
                height: '100px',
                color: '#08c',
                margin: 'auto',
                marginBottom: '20px',
              }}
            >
              <MdHourglassEmpty size={100} />
            </div>

            <div
              style={{
                fontSize: '18px',
                color: '#43637c',
                height: 'auto',
                maxWidth: '500px',
                textAlign: 'center',
                fontWeight: 500,
                margin: 'auto',
                marginBottom: '20px',
                lineHeight: '25px',
              }}
            >
              <h4>Online Freight Marketplace</h4>
            </div>
            <div
              style={{
                fontSize: '18px',
                color: '#43637c',
                textAlign: 'center',
                width: '100%',
                height: 'auto',
                marginBottom: '20px',
                marginTop: 0,
                margin: 'auto',
              }}
            >
              <p>
                Please input place of origin, place of discharge, select the
                transport mode, select the date and click "Search"
              </p>
            </div>
          </div>
        </Card>
      </div>
        </div>
    </>
  );
};

export default StartCard;
